import script from "./OrderDetailsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderDetailsModal.vue?vue&type=script&setup=true&lang=js"

import "./OrderDetailsModal.vue?vue&type=style&index=0&id=e5ea470e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5ea470e"]])

export default __exports__